import React, { JSX, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthService } from "./index";
import { RoutePaths } from "../routes/routePaths";

const PrivateRoute = ({
  component: Component,
  ...rest
}): JSX.Element | null => {
  const [isUserLogged, setIsUserLogged] = useState<boolean | undefined>(
    () => undefined,
  );

  useEffect(() => {
    AuthService.isLogged().then((userStatus: boolean) =>
      setIsUserLogged(userStatus),
    );
  }, []);

  if (isUserLogged === undefined) {
    return null;
  }

  if (!isUserLogged) {
    return (
      <Navigate
        to={{
          pathname: RoutePaths.LOGIN,
        }}
      />
    );
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
